import { createSlice } from '@reduxjs/toolkit';
import { v4 as uuid } from 'uuid';

const initialState = {
  items:      [],
  selectedId: null,
};

const imageOverlaySlice = createSlice({
  name: 'imageOverlay',
  initialState,
  reducers: {
    addItem(state, { payload }) { 
      const id = payload.id ?? uuid();
      state.items.push({ rotation: 0, selected: false, ...payload, id });
    },
    updateItem(state, { payload }) {
      const idx = state.items.findIndex((i) => i.id === payload.id);
      if (idx !== -1) state.items[idx] = { ...state.items[idx], ...payload };
    },
    removeItem(state, { payload }) {
      state.items     = state.items.filter((i) => i.id !== payload);
      if (state.selectedId === payload) state.selectedId = null;
    },
    selectItem(state, { payload }) {
      state.items     = state.items.map((i) => ({ ...i, selected: i.id === payload }));
      state.selectedId = payload;
    },
    clearItemSelection(state) {
      state.items     = state.items.map((i) => ({ ...i, selected: false }));
      state.selectedId = null;
    },
    setAllItems(state, { payload }) {
      state.items      = payload;
      state.selectedId = null;
    },
    clearAllItems(state) {
      state.items      = [];
      state.selectedId = null;
    },
  },
});

export const { addItem, updateItem, removeItem, selectItem, clearItemSelection, setAllItems, clearAllItems } =
  imageOverlaySlice.actions;
export default imageOverlaySlice.reducer;